exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".game-holder.video {\n  display: none; }\n\n.game-holder.tickets {\n  display: none; }\n\n#tabs {\n  display: none; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/games/lucky-balls/scss/terminal/terminal.scss
// module id = 1164
// module chunks = 2